/**
 * Elements for extending the DOM with useful functionality.
 *
 * Note that caution should be used here as to prevent name collisions.
 * Probably only super useful functions should be included here.
 *
 * @usage:
 *
 * 	var element = document.getElementById( 'the_id' );
 *
 * 	element.onClickTap( function() {
 * 		// Do something useful when clicked or tapped but not dragged.
 * 		// Ignores annoying phantom clicks.
 * 	});
 *
 *
 * @author HGB3 12/22/2016
 */


/**
 * Sets up an event handler for both tap and click events in such a way
 * that we prevent "phantom taps" -- when both the click event and the
 * touchend events are fired for one event. Also tests for and ignores
 * drag events.
 *
 * @param function handler - the function to handle the event
 * @param element - element on which to put the events
 */
Element.prototype.onClickTap = function( handler, element ) {
	var element = element || this; // Create a closure on the element

	var dragging = false; // Create a closure on a dragging flag

	/**
	 * Notice and flag drag events to ignore.
	 */
	jQuery( element ).on( 'touchmove', function ( event ) {
		dragging = true;
	});

	/**
	 * Handles touchend events (when not dragging).
	 */
	jQuery( element ).on( 'touchend', function ( event ) {
		if ( ! dragging ) {
			handler( event );
		}
		dragging = false;  // We are at the end of the 'touch', so reset dragging flag
		element.tapEventHandled = true;
	});

	/**
	 * When this event is fired, check to see if the element's
	 * tabEventHandled flag was set. If so, unset it.
	 * If not, handle the event like normal.
	 */
	jQuery( element ).on( 'click', function ( event ) {
		if ( element.tapEventHandled ) {
			element.tapEventHandled = false;
			return;
		}
		if ( ! dragging ) {
			handler( event );
		}
	});
};


/**
 * Sets up an event handler for *only* click events. Tap events, which
 * should happen first, will prevent the handler from being run.
 *
 * @param function handler - the function to handle the event
 */
Element.prototype.onClickTap = function( handler, element ) {
	var element = element || this; // Create a closure on the element

	/**
	 * Handles touchstart events.
	 */
	jQuery( element ).on( 'touchstart', function ( event ) {
		element.tapEventHappened = true;
	});

	/**
	 * When this event is fired, check to see if the element's
	 * tabEventHandled flag was set. If so, unset it for the next time.
	 * If not, handle the event like normal.
	 */
	jQuery( element ).on( 'click', function ( event ) {
		if ( element.tapEventHappened ) {
			element.tapEventHappened = false;
		} else {
			handler( event );
		}
	});
};
